var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('FormInputTextarea',{attrs:{"disabled":_vm.isStepDisabled,"input-label":_vm.formLabels.userNotes},model:{value:(_vm.userFormInput.userNotes),callback:function ($$v) {_vm.$set(_vm.userFormInput, "userNotes", $$v)},expression:"userFormInput.userNotes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }